import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/audit';
interface CTAButtonProps {
  label: string;
  subLabel?: string;
  variant?: 'gold' | 'light';
  id?: string;
}
export function CTAButton({
  label,
  subLabel,
  variant = 'gold',
  id
}: CTAButtonProps) {
  const isGold = variant === 'gold';
  return <div className="flex w-full flex-col items-center" id={id} data-id="element-139" data-mp="2g1o8al0szad7">
      <a href={CHECKOUT_URL} className={['group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl px-6 py-5 text-center text-base font-extrabold uppercase leading-tight tracking-wide', 'shadow-[0_10px_30px_-8px_rgba(11,27,47,0.45)] transition-[transform,box-shadow,background-color] duration-200 ease-out', 'hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-10px_rgba(11,27,47,0.5)] active:translate-y-0', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-500', 'sm:text-lg', isGold ? 'bg-gold-500 text-navy-950 hover:bg-gold-400' : 'bg-white text-navy-900 hover:bg-cream-100'].join(' ')} data-id="element-140" data-mp="2tyb8cwo1ygnc">
        <span data-id="element-141" data-mp="1i9bh94w3ojne">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-142" data-mp="1i801s7talngg" />
      </a>
      {subLabel && <p className={['mt-3 max-w-md text-center text-[11px] font-semibold uppercase tracking-[0.12em] sm:text-xs', isGold ? 'text-navy-700' : 'text-gold-200'].join(' ')} data-id="element-143" data-mp="1s7935lqhm4cu">
          {subLabel}
        </p>}
    </div>;
}